import { useEffect, useRef, useState } from "react";
import "../App.css";
import Layout from "../Components/Layout";
import socketIO from "socket.io-client";
import { useNavigate } from "react-router-dom";
import SocketContext from "../Contexts/SocketContext";
import axios from "axios";
function ProtectedRoutes() {
  const [socket, setSocket] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let tmp = socketIO.connect(process.env.REACT_APP_SERVER_URL);
    setSocket(tmp);
    verifyToken();
    return () => {
      if (socket) {
        socket.disconnect();
      }
    };
  }, []);

  const verifyToken = () => {
    axios
      .post("/api/verify-token", {
        token: localStorage.getItem("token"),
      })
      .then((response) => {
        if (response?.data?.success) {
        } else {
          navigate("/login");
        }
      })
      .catch(({ response }) => {
        navigate("/login");
      });
  };

  return (
    <div className="h-full">
      <SocketContext.Provider value={socket}>
        <Layout onLinkClick={() => {}} />
      </SocketContext.Provider>
    </div>
  );
}

export default ProtectedRoutes;
